import React, { Component } from 'react'
import styled from 'styled-components'
import MoneyConfig from '../components/MoneyConfig'
import RateConfig from '../components/RateConfig'
import Title from '../components/Title'
import bg1 from '../assets/img/bg1.png'
import { vw } from '../untils/styled'
import { calc, getNav } from '../service/'
import Toast , { T } from 'react-toast-mobile'
import 'react-toast-mobile/lib/react-toast-mobile.css'
import { ClientCalcAssetAllocation } from '../untils/sa-event'
import { 
    DialogGetReport
} from '../components/dialogs'

const Body = styled.div`
    width: 100%;
    background: url(${bg1});
    background-size: 100% auto;
    padding-bottom: ${vw(200)};
`

const TitleWrapper = styled.div`
    padding-top: ${props => vw(props.pt)};
    margin-bottom: ${props => vw(props.mb || 0)};
`

const MoneyWrapper = styled.div`
    margin-top: ${vw(190)};
`

const SubmitButton = styled.div`
    position: fixed;
    bottom: 0;
	background-image: linear-gradient(90deg, #fcd78d 0%, #bd8e4c 100%);
    width: 100%;
    height: ${vw(100)};
    line-height: ${vw(100)};
    text-align: center;
    color: #fff;
    font-size: ${vw(36)};
    z-index: 100;
    /* opacity: 1; */
    opacity: ${props => props.show ? '1' : '0'};
    transition: opacity 1s;
`

export default class Calculate extends Component {
    constructor() {
        super()
        this.money = null
        this.rate = null
        this.state = {
            submitShow: false,
            getReport: false,
            renderData: {
                calc: {},
                nav: {}
            }
        }
        this.firstSubmit = true
    }
    componentDidMount () {
        const scrollWrapper = document.querySelector('.App')
        scrollWrapper.addEventListener('scroll', this.scroll)
    }
    scroll = () => {
        const scrollWrapper = document.querySelector('.App')
        if (scrollWrapper.scrollTop > 400 && !this.state.submitShow) {
            this.setState(pre => ({
                submitShow: true
            }))
        } else if (scrollWrapper.scrollTop < 400 && this.state.submitShow) {
            this.setState(pre => ({
                submitShow: false
            }))
        }
    }
    changeMoney = value => {
        this.money = value;
    }
    changeRate = value => {
        this.rate = value;
    }
    changeGetReport = value => {
        this.setState({
            getReport: value
        })
    }
    canSubmit = () => {
        let number = 0;
        let total = 0;
        if (this.money === 0) {
            T.notify('请设置配置金额')
            return false
        }
        this.rate.forEach(item => {
            if (item.value !== 0) {
                number++
            }
            total += item.value
        })
        if (number < 3) {
            T.notify('请至少设置3类标的')
            return false
        }
        if (total !== 100) {
            T.notify('请设置资产比例达到100%')
            return false
        }
        return true
    }
    nextStep = () => {
        this.props.nextStep(this.state.renderData.calc, this.state.renderData.nav);
    }
    submit = () => {
        if (!this.canSubmit()) return
        if (this.firstSubmit) {
            this.changeGetReport(true)
        }
        ClientCalcAssetAllocation([
            this.rate[0].value,
            this.rate[1].value,
            this.rate[2].value,
            this.rate[3].value,
            this.rate[4].value,
            this.rate[5].value
        ])
        let params = {
            amount: this.money * 10000,
            allocationRatioBond: this.rate[0].value / 100,
            allocationRatioOil: this.rate[1].value / 100,
            allocationRatioGold: this.rate[2].value / 100,
            allocationRatioSp500: this.rate[3].value / 100,
            allocationRatioHs300: this.rate[4].value / 100,
            allocationRatioZz500: this.rate[5].value / 100
        }
        if (!this.firstSubmit) {
            T.loading('资产配置穿越牛熊市，追求中长期稳健收益')
        }
        // 记得做次数限制
        calc(params).then(res => {
            if (res.rstcode === '000000') {
                let updateArr = []
                // 抽出的公共回调处理
                function handleResponse (res) {
                    if (res.rstcode === '000000') {
                        return res.datalist;
                    } else {
                        return Promise.reject();
                    }
                }
                let navZL = getNav({
                    assetCode: 'ZL'
                }).then(res => {
                    return handleResponse(res)
                })
                updateArr.push(navZL);
                let navHS300 = getNav({
                    assetCode: '000300'
                }).then(res => {
                    return handleResponse(res)
                })
                updateArr.push(navHS300);
                let navSerialno = getNav({
                    serialNo: res.data.serialno
                }).then(res => {
                    return handleResponse(res)
                })
                updateArr.push(navSerialno);

                // 所有请求成功
                Promise.all(updateArr).then(navResp => {
                    this.setState({
                        renderData: {
                            calc: res.data,
                            nav: {
                                ZL: navResp[0],
                                HS: navResp[1],
                                KH: navResp[2]
                            }
                        }
                    })                    
                    if (!this.firstSubmit) {
                        T.loaded()
                        this.nextStep()
                    }
                }, err => {
                    if (!this.firstSubmit) {
                        T.loaded()
                    }
                    console.log(err);
                });
            }
        })
    }
    render() {
        return (
            <Body>
                <TitleWrapper pt={524}>
                    <Title mainTitle='请设置配置金额'></Title>
                </TitleWrapper>
                <MoneyWrapper>
                    <MoneyConfig valueSubmit={this.changeMoney}></MoneyConfig>
                </MoneyWrapper>
                <TitleWrapper pt={150} mb={46}>
                    <Title
                        mainTitle='请设置大类资产投资比例'
                        subTitle='（至少选择3项且投资总和为100%）'
                        ></Title>
                </TitleWrapper>
                <RateConfig valueSubmit={this.changeRate}></RateConfig>
                <SubmitButton show={this.state.submitShow} onClick={this.submit}>开始计算</SubmitButton>
                <Toast></Toast>
                {
                    this.state.getReport && <DialogGetReport serialno={this.state.renderData.calc.serialno} next={this.nextStep} changeState={this.changeGetReport}></DialogGetReport>
                }
            </Body>
        )
    }
}
